import { Component, OnInit } from '@angular/core';
import { InstanceService } from '../../services/instance.service';
import { getDeepestRouteSnapshot } from '@finra/rampdi-forms-common';
import { ActivatedRoute } from '@angular/router';
import { environment, Versions } from 'projects/app-mu3-form/src/environments/environment';
import { DisplayRulesService } from '../../services/display-rules.service';

@Component({
  selector: 'app-post-submission',
  templateUrl: './post-submission.component.html',
  styleUrls: ['./post-submission.component.scss'],
})
export class PostSubmissionComponent implements OnInit {
  notificationEmail: string = 'your registered email';
  dataLoaded = false;

  constructor(
    private instanceService: InstanceService,
    private route: ActivatedRoute,
    private DS: DisplayRulesService,
  ) {}

  ngOnInit() {
    this.dataLoaded = true;
  }

  finishRouting() {
    const currentEnvVersion =
      environment.versions[
        (this.instanceService.currentInstance.templateVersion ?? environment.currentVersion) as Versions
      ];
    const url = this.DS.userPermissions.isCompanyUser
      ? currentEnvVersion.urls.workManagement
      : currentEnvVersion.urls.individualProfile + '?activeTab=home';
    window.open(url, '_self');
  }

  getSnapShot() {
    return getDeepestRouteSnapshot(this.route)?.data;
  }
}
